import { axiosClient } from "./axiosClient"

export const LOCATION_PATH = '/api/v1/location'

export const addLocation = (body) => {
    return axiosClient.post(LOCATION_PATH, body)
}

export const updateLocation = (id, body) => {
    return axiosClient.put(`${LOCATION_PATH}/${id}`, body)
}

export const deleteLocation = (id) => {
    return axiosClient.delete(`${LOCATION_PATH}/${id}`)
}

export const getLocationById = (id) => {
    return axiosClient.get(`${LOCATION_PATH}/${id}`)
}

export const getPageLocations = ({ search = "", lastId = '', id = "", code = '', name = '' }) => {
    return axiosClient.get(`${LOCATION_PATH}/page?search=${search}&lastId=${lastId}&id=${id}&code=${code}&name=${name}`)
}
